export const GLOBAL_REPORT_AGENT_MODE_CHAT = "chat";
export const GLOBAL_REPORT_AGENT_MODE_INSIGHTS = "insights";
